import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';

import './index.css';
import 'antd/dist/antd.css';
import App from './App';
import { store } from './app/store';
import reportWebVitals from './reportWebVitals';
import CustomErrorBoundary from 'components/ErrorBoundary';
import { QueryClient, QueryClientProvider } from 'react-query';
import { CubeProvider } from '@cubejs-client/react';
import cubejsApi from './utils/cubejs';

const queryClient = new QueryClient();
Sentry.init({
  dsn: 'https://f6aacf51c15e43cb8a4e926f665320e9@o1157378.ingest.sentry.io/6581501',
  integrations: [new BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});

const container = document.getElementById('root');

ReactDOM.render(
  <React.StrictMode>
    <CustomErrorBoundary>
      <BrowserRouter basename='/'>
        <Provider store={store}>
          <QueryClientProvider client={queryClient}>
            <CubeProvider cubeApi={cubejsApi}>
              <App />
            </CubeProvider>
          </QueryClientProvider>
        </Provider>
      </BrowserRouter>
    </CustomErrorBoundary>
  </React.StrictMode>,
  container
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();